import { SidebarMenuButton, SidebarMenuItem } from '@components/ui/sidebar';
import { isRouteItemActive, RouteItem } from '@utils/route-utils';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC } from 'react';

type NavItemProps = {
  item: RouteItem;
};

const NavItem: FC<NavItemProps> = ({ item }) => {
  const pathname = usePathname();
  const active = isRouteItemActive(pathname, item);

  return (
    <SidebarMenuItem key={item.id}>
      <SidebarMenuButton
        asChild
        isActive={active}
        tooltip={item.label}
        size={item.size || 'default'}
      >
        <Link href={item.href} aria-current={active ? 'page' : undefined}>
          {item.icon && <item.icon />}
          <span>{item.label}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

export default NavItem;
